import { http, readCookie } from '../../services/http';
import type { LoginResult, Me } from './types';

const noRefresh = { skipRefresh: true } as const;

export const authApi = {
  login: (body: { workspace: string; email: string; password: string }) =>
    http.post<LoginResult>('/auth/login', { ...body, client: 'web' }, noRefresh),
  platformLogin: (body: { email: string; password: string; totpCode?: string }) =>
    http.post<LoginResult>('/auth/platform/login', { ...body, client: 'web' }, noRefresh),
  logout: () =>
    http.post<void>('/auth/logout', undefined, {
      ...noRefresh,
      headers: { 'X-CSRF-Token': readCookie('lm_csrf') ?? '' },
    }),
  logoutAll: () => http.post<void>('/auth/logout-all'),
  me: () => http.get<Me>('/auth/me'),
  forgot: (body: { workspace?: string; email: string }) =>
    http.post<{ message: string }>('/auth/password/forgot', body, noRefresh),
  reset: (body: { token: string; newPassword: string }) =>
    http.post<void>('/auth/password/reset', body, noRefresh),
  changePassword: (body: { currentPassword: string; newPassword: string }) =>
    http.post<void>('/auth/password/change', body),
  previewInvitation: (token: string) =>
    http.post<{
      email: string;
      fullName: string;
      workspace: string | null;
      tenantName: string | null;
      isPlatformAdmin: boolean;
      expiresAt: string;
    }>('/auth/invitations/preview', { token }, noRefresh),
  acceptInvitation: (body: { token: string; fullName: string; password: string }) =>
    http.post<{ workspace: string | null; email: string }>('/auth/invitations/accept', body, noRefresh),
  sessions: () =>
    http.get<
      { id: string; client: string; userAgent: string | null; lastUsedAt: string; current: boolean }[]
    >('/auth/sessions'),
  revokeSession: (id: string) => http.delete<void>(`/auth/sessions/${id}`),
};
